var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconTrash } from "@tabler/icons-react";
import { REJECTION_CODES_TABLE_HEADERS, REJECTION_CODES_TRANSACTION_LABEL_ES, } from "../constants/rejectionCodes.constants";
import { CodesTableDeleteButton } from "./codesTableColumns.style";
var TRANSACTION_TAG_TONE_BY_VALUE = {
    CREDIT: "positive",
    DEBIT: "info",
    REBILL: "warning",
    REJECTED: "negative",
    CANCELLED: "neutral",
};
var TRANSACTION_TAG_TONE_BY_LABEL = Object.fromEntries(Object.entries(TRANSACTION_TAG_TONE_BY_VALUE).map(function (_a) {
    var value = _a[0], tone = _a[1];
    return [
        REJECTION_CODES_TRANSACTION_LABEL_ES[value],
        tone,
    ];
}));
var TRANSACTION_SELECT_OPTIONS = Object.entries(REJECTION_CODES_TRANSACTION_LABEL_ES).map(function (_a) {
    var label = _a[1];
    return ({ value: label, label: label });
});
export var toCodesTableRow = function (code) {
    var _a, _b, _c, _d;
    return ({
        id: code.id,
        values: {
            code: (_a = code.code) !== null && _a !== void 0 ? _a : "",
            label: (_b = code.label) !== null && _b !== void 0 ? _b : "",
            transaction: REJECTION_CODES_TRANSACTION_LABEL_ES[code.transaction],
            description: code.description,
            action: (_c = code.action) !== null && _c !== void 0 ? _c : "",
            actionDescription: (_d = code.actionDescription) !== null && _d !== void 0 ? _d : "",
        },
    });
};
var buildBaseCodesTableColumns = function (editable) { return [
    {
        key: "code",
        header: REJECTION_CODES_TABLE_HEADERS.code,
        width: "90px",
        monospace: true,
        editable: editable,
    },
    {
        key: "label",
        header: REJECTION_CODES_TABLE_HEADERS.label,
        width: "120px",
        editable: editable,
    },
    {
        key: "transaction",
        header: REJECTION_CODES_TABLE_HEADERS.transaction,
        width: "135px",
        tag: true,
        tagTone: function (value) { var _a; return (_a = TRANSACTION_TAG_TONE_BY_LABEL[value]) !== null && _a !== void 0 ? _a : "neutral"; },
        select: { data: TRANSACTION_SELECT_OPTIONS, searchable: false },
        editable: editable,
    },
    {
        key: "description",
        header: REJECTION_CODES_TABLE_HEADERS.description,
        width: "250px",
        editable: editable,
    },
    {
        key: "action",
        header: REJECTION_CODES_TABLE_HEADERS.action,
        width: "100px",
        editable: editable,
    },
    {
        key: "actionDescription",
        header: REJECTION_CODES_TABLE_HEADERS.actionDescription,
        width: "200px",
        editable: editable,
    },
]; };
export var CODES_TABLE_COLUMNS = buildBaseCodesTableColumns(true);
export var buildCodesTableColumnsWithDelete = function (onDelete, editingId) { return __spreadArray(__spreadArray([], buildBaseCodesTableColumns(true), true), [
    {
        key: "__delete",
        header: "",
        width: "48px",
        render: function (row) {
            return row.id === editingId ? null : (_jsx(CodesTableDeleteButton, __assign({ type: "button", "aria-label": "Eliminar", onClick: function () { return onDelete(row.id); } }, { children: _jsx(IconTrash, { size: 14 }) })));
        },
    },
], false); };
export var buildReadOnlyCodesTableColumns = function () {
    return buildBaseCodesTableColumns(false);
};
